import { createMuiTheme } from "@material-ui/core";
import color from "../constants/Color";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
declare module "@material-ui/core/styles/createBreakpoints" {
	interface BreakpointOverrides {
		xs: true;
		sm: true;
		md: true;
		lg: true;
		hidpi: true;
		xl: true;
	}
}

const theme = createMuiTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 960,
			lg: 1280,
			hidpi: 1440,
			xl: 1920,
		},
	},
	palette: {
		background: {
			default: "#1b2a47",
			paper: "#152036",
		},
		primary: {
			main: color.primary,
		},
		secondary: {
			main: color.secondary,
		},
		warning: {
			main: color.warning,
		},
		success: {
			main: color.success,
		},
		error: {
			main: color.error,
		},
		text: {
			primary: color.textPrimary,
		},
	},
	typography: {
		allVariants: {
			color: color.white,
		},
		htmlFontSize: 14,
		fontSize: 14,
		fontFamily: `"roboto", sans-serif`,
		body1: {
			fontSize: "1rem",
		},
		body2: {
			fontSize: "0.85rem",
		},
		h6: {
			fontSize: "1rem",
			fontWeight: 500,
		},
		h5: {
			fontSize: "1.25rem",
			fontWeight: 500,
		},
		h4: {
			fontSize: "1.5rem",
			fontWeight: 500,
		},
	},
	overrides: {
		MuiButton: {
			root: {
				textTransform: "none",
				padding: "0.75rem 2rem",
				fontSize: "1rem",
				lineHeight: "2rem",
				borderRadius: "5px",
				fontWeight: 500,
				boxShadow: "none",
				"&:hover  .MuiSvgIcon-root": {
					padding: "0.125rem",
					fontSize: "2rem",
				},
			},
			contained: {
				padding: "0.75rem 2rem",
				fontSize: "1rem",
				lineHeight: "2rem",
				boxShadow: "none",
				backgroundColor: color.lightDark1,
				color: color.lightDark2,
				borderWidth: 1,
				borderStyle: "solid",
				borderColor: color.lightDark1,
				"&:hover": {
					boxShadow: "none",
					color: color.primary,
					borderColor: color.primary,
					borderWidth: 1,
					borderStyle: "solid",
					backgroundColor: color.white,
				},
				"&.Mui-disabled": {
					backgroundColor: "#F3F3F3",
					borderColor: "#F3F3F3",
					color: "#A6A6A6",
				},
			},
			outlined: {
				padding: "0.75rem 2rem",
				fontSize: "1rem",
				lineHeight: "2rem",
			},
			containedSecondary: {
				color: color.white,
				borderWidth: 1,
				borderStyle: "solid",
				borderColor: color.secondary,
				"&:hover": {
					boxShadow: "none",
					color: color.white,
					borderColor: color.darkSecondary,
					borderWidth: 1,
					borderStyle: "solid",
					backgroundColor: color.darkSecondary,
				},
			},
			containedPrimary: {
				color: color.white,
				borderWidth: 1,
				borderStyle: "solid",
				borderColor: color.primary,
				"&:hover": {
					boxShadow: "none",
					color: color.white,
					// borderColor: color.darkPrimary,
					borderWidth: 1,
					borderStyle: "solid",
					// backgroundColor: color.darkPrimary,
				},
			},
			iconSizeMedium: {
				"& *:first-child": {
					fontSize: "2rem",
					padding: "0.25rem",
				},
			},
			iconSizeSmall: {
				"& *:first-child": {
					fontSize: "1.25rem",
					padding: "0.25rem",
				},
			},
			iconSizeLarge: {
				"& *:first-child": {
					fontSize: "2rem",
					padding: "0.25rem",
				},
			},
			startIcon: {
				marginRight: "4px",
			},
		},
		MuiIconButton: {
			root: {
				color: "white",
			},
			colorPrimary: {
				border: "1px solid",
				borderColor: color.primary,
				"&:hover": {
					color: "white",
					backgroundColor: color.primary,
					borderColor: color.primary,
					border: "1px solid",
				},
				"&.Mui-disabled": {
					borderColor: color.grey200,
				},
			},
			colorSecondary: {
				border: "1px solid",
				color: color.secondary,
				borderColor: color.secondary,
				backgroundColor: "#fff",
				"&:hover": {
					color: "white",
					backgroundColor: color.secondary,
					borderColor: color.secondary,
					border: "1px solid",
					"&.Mui-disabled": {
						borderColor: color.grey200,
					},
				},
			},
			sizeSmall: {
				padding: "8px",
				"& .MuiSvgIcon-root": {
					fontSize: "1rem",
				},
			},
		},
		MuiCheckbox: {
			root: {
				padding: 0,
				background: "none",
				border: "none",
				"&:hover": {
					background: "none",
					border: "none",
				},
			},
			colorPrimary: {
				border: "none",
				"&:hover": {
					color: "rgba(0, 0, 0, 0.54)",
					border: "none",
					backgroundColor: "transparent",
				},
			},
		},
		MuiTypography: {
			body1: {
				fontSize: "1rem",
				fontWeight: 400,
			},
			body2: {
				fontSize: "0.85rem",
			},
			h6: {
				fontSize: "1rem",
				fontWeight: 500,
			},
			h5: {
				fontSize: "1.25rem",
				fontWeight: 500,
			},
			h4: {
				fontSize: "1.5rem",
				fontWeight: 500,
			},
			h3: {
				fontSize: "2rem",
				fontWeight: 500,
			},
			h2: {
				fontSize: "3rem",
				fontWeight: 500,
			},
			subtitle2: {
				fontSize: "1rem",
				fontWeight: 500,
			},
		},
		MuiInputBase: {
			root : {
			},
			input: {
				border : "none",
				height: "fit-content",
				"&[type=password]::-ms-reveal": {
					display: "none",
				},
				"&[type=password]::-ms-clear": {
					display: "none",
				},
			},
			
		},
		MuiInput: {
			input: {
				borderBottom: "white",
				color: "white",
			},
		},
		MuiOutlinedInput: {
			inputMarginDense: {
				paddingTop: "1rem",
				paddingRight: "1rem",
			},
			input: {
				padding: "1.25rem 1rem",
				fontSize: "1rem",
				lineHeight: "1rem",
				height: "calc(1rem + 1px)",
			},
		},
		MuiInputLabel: {
			outlined: {
				transform: "translate(14px, 1.25rem) scale(1)",
			},
		},
		MuiSelect: {
			select: {
				// "&:focus": {
				// 	backgroundColor: color.white,
				// },
				"&.Mui-disabled": {
					cursor: "not-allowed",
					backgroundColor: color.disabledBackground,
				},
			},
		},
		MuiListItemIcon : {
			root : {
				color : "white"
			}
		},
		MuiSvgIcon : {
			root : {
				color :  "white"
			}
		},
		MuiTableCell: {
			root: {
				"&:first-child": {
					paddingLeft: 0,
				},
			},
			head: {
				fontSize: 14,
				color: color.textPrimary,
				fontWeight: 400,
				"&(:first-child)": {
					textAlign: "left",
				},
				"&:not(:first-child):not(:last-child)": {
					textAlign: "center",
				},
			},
			body: {
				fontSize: 14,
				color: color.textPrimary,
				fontWeight: 400,
				"&(:first-child)": {
					textAlign: "left",
					paddingLeft: 0,
				},
				"&:not(:first-child):not(:last-child)": {
					textAlign: "center",
				},
			},
		},
		MuiTableSortLabel: {
			icon: {
				display: "none",
			},
		},
		MuiTablePagination: {
			toolbar: {
				padding: 0,
				margin: "45px auto",
				minHeight: 50,
				textAlign: "center",
				justifyContent: "center",
			},
			spacer: {
				display: "none",
			},
			caption: {
				display: "none",
			},
			input: {
				display: "none",
			},
		},
		MuiTableRow: {
			root: {
				height: "65px",
				"& #demo-simple-select-outlined": {
					backgroundColor: "#F0F0F0",
					fontSize: "0.85rem",
					lineHeight: "1.5rem",
					padding: "0.75rem 1rem",
					borderRadius: "4px",
				},
				"& .MuiOutlinedInput-notchedOutline": {
					border: "none !important",
				},
				"& .MuiTableCell-root": {
					maxWidth: "300px",
				},
				"& .MuiChip-root": {
					borderRadius: "4px",
					backgroundColor: "#F0F0F0",
					// margin: "8px 8px 8px 0",
					height: "fit-content",
					padding: "4px 12px",
					"& .MuiChip-label": {
						lineHeight: "17px",
						fontSize: "0.85rem",
						color: color.textPrimary,
					},
				},
			},
		},
		MuiSnackbar: {
			root: {
				top: "132px !important",
			},
		},
		MuiDialog: {
			paper: {
				padding: "24px",
				boxShadow : "none"
			},
		},
		MuiAccordion : {
			root : {
				padding : 0
			}
		}
	},
});

export default theme;
